<template>
  <nav class="language-switcher">
    <ul class="language-switcher__list">
      <li
        class="language-switcher__item"
        v-for="lang in langsList"
        :key="lang.code"
      >
        <span
          class="language-switcher__link"
          :class="{ 'language-switcher__link--active': lang.code === $i18n.locale }"
          @click="switchLocale(lang.code)"
        >
          {{ lang.name }}
        </span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  setup() {
    const langsList = [
      { code: 'uk', name: 'Мова' },
      { code: 'ru', name: 'Язык' },
      { code: 'en', name: 'Language' },
    ];

    return { langsList };
  },
  watch: {
    '$route.params'(toParams) {
      this.switchLocale(toParams.locale);
    },
  },
  methods: {
    switchLocale(locale) {
      if (this.$i18n.locale === locale) {
        return;
      }

      this.$i18n.locale = locale;

      const routeWithNewLocale = {
        name: this.$route.name,
        params: {
          ...this.$route.params,
          locale,
        },
        query: {
          ...this.$route.query,
        },
      };

      this.$store.dispatch('control/setWidgetAction', {
        type: 'widget-locale',
        value: locale,
      });

      this.$router.push(routeWithNewLocale);
    },
  },
};
</script>

<style lang="scss">
.language-switcher {
  $this: 'language-switcher';

  &__list {
    display: flex;
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  &__item {
    font-size: 12px;

    &:not(:last-child) {
      margin-right: 5px;
    }
  }

  &__link {
    color: $color-dodger-blue;
    text-decoration: underline;
    cursor: pointer;

    &--active {
      text-decoration: none;
      color: $color-black;
    }
  }
}
</style>
